var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal",
    {
      attrs: { "show-footer": false, "show-title": false },
      on: { cancel: _vm.close },
    },
    [
      _c("div", { staticClass: "limited-modal" }, [
        _c("div", { staticClass: "limited-modal-title" }, [
          _c("span", { staticClass: "material-icons alert-icon" }, [
            _vm._v("warning"),
          ]),
          _vm._v(
            "\n            " +
              _vm._s(_vm.$t("billing.limitedModalTitle")) +
              "\n            "
          ),
          _c(
            "div",
            { staticStyle: { "font-size": "16px", "margin-top": "10px" } },
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("billing.limitedModalSubtitle")) +
                  "\n            "
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "limited-modal-description" }, [
          _c("div", { staticClass: "limited-modal-description-text" }, [
            _vm._v(
              "\n                " +
                _vm._s(_vm.$t("billing.limitedModalIntro")) +
                "\n            "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "limited-modal-description-content" }, [
            _vm.shouldSelectPlan.enabled
              ? _c("div", { staticClass: "information-detail" }, [
                  _c("div", { staticClass: "information-detail-text" }, [
                    _c("b", [
                      _vm._v(
                        _vm._s(_vm.$t("billing.limitedModalRequiredAdditions"))
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "information-detail-text-items" },
                      [
                        _vm.shouldSelectPlan.supsisPackage
                          ? _c("div", [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm.$t("billing.limitedModalLineAgents", {
                                      shortfall:
                                        _vm.shouldSelectPlan.details.current
                                          .users -
                                        _vm.shouldSelectPlan.details.limit
                                          .currentSupsisAgentCount,
                                      current:
                                        _vm.shouldSelectPlan.details.current
                                          .users,
                                      limit:
                                        _vm.shouldSelectPlan.details.limit
                                          .currentSupsisAgentCount,
                                    })
                                  ) +
                                  "\n                            "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.shouldSelectPlan.whatsappQr
                          ? _c("div", [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm.$t(
                                      "billing.limitedModalLineWhatsappQr",
                                      {
                                        shortfall:
                                          _vm.shouldSelectPlan.details.current
                                            .whatsappQr -
                                          _vm.shouldSelectPlan.details.limit
                                            .currentWhatsappPlanCount,
                                        current:
                                          _vm.shouldSelectPlan.details.current
                                            .whatsappQr,
                                        limit:
                                          _vm.shouldSelectPlan.details.limit
                                            .currentWhatsappPlanCount,
                                      }
                                    )
                                  ) +
                                  "\n                            "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.shouldSelectPlan.whatsappBusiness
                          ? _c("div", [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm.$t(
                                      "billing.limitedModalLineWhatsappBusiness",
                                      {
                                        shortfall:
                                          _vm.shouldSelectPlan.details.current
                                            .whatsappBusinessChannels -
                                          _vm.shouldSelectPlan.details.limit
                                            .currentWhatsappBusinessChannelCount,
                                        current:
                                          _vm.shouldSelectPlan.details.current
                                            .whatsappBusinessChannels,
                                        limit:
                                          _vm.shouldSelectPlan.details.limit
                                            .currentWhatsappBusinessChannelCount,
                                      }
                                    )
                                  ) +
                                  "\n                            "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.shouldSelectPlan.instagram
                          ? _c("div", [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm.$t(
                                      "billing.limitedModalLineInstagram",
                                      {
                                        shortfall:
                                          _vm.shouldSelectPlan.details.current
                                            .instagram -
                                          _vm.shouldSelectPlan.details.limit
                                            .instagram,
                                        current:
                                          _vm.shouldSelectPlan.details.current
                                            .instagram,
                                        limit:
                                          _vm.shouldSelectPlan.details.limit
                                            .instagram,
                                      }
                                    )
                                  ) +
                                  "\n                            "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.shouldSelectPlan.messenger
                          ? _c("div", [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm.$t(
                                      "billing.limitedModalLineMessenger",
                                      {
                                        shortfall:
                                          _vm.shouldSelectPlan.details.current
                                            .messenger -
                                          _vm.shouldSelectPlan.details.limit
                                            .messenger,
                                        current:
                                          _vm.shouldSelectPlan.details.current
                                            .messenger,
                                        limit:
                                          _vm.shouldSelectPlan.details.limit
                                            .messenger,
                                      }
                                    )
                                  ) +
                                  "\n                            "
                              ),
                            ])
                          : _vm._e(),
                      ]
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "limited-modal-footer",
                staticStyle: { "margin-top": "30px" },
              },
              [
                _c(
                  "SupsisButton",
                  {
                    staticStyle: { width: "250px" },
                    attrs: { primary: "" },
                    on: { click: _vm.confirm },
                  },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("billing.limitedModalGoPackages")) +
                        "\n                    "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "margin-top": "15px",
                      "font-size": "12px",
                      color: "#666",
                    },
                  },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("billing.limitedModalFooterNote")) +
                        "\n                    "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }